import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {NotificationModule} from 'app/management/notification/notification.module';

@NgModule({
    imports: [
        NotificationModule
    ],
    declarations: [
    ],
    entryComponents: [
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BalrogadminManagementModule {}
